export const NavigationEnum = {
    CONFIRM: "CONFIRM",
    ENTER_AMOUNT: "ENTER_AMOUNT",
    SUCCESS: "SUCCESS",
};
